<template>
  <div class="relative">
    <div v-if="direction === 'right'" class="flex justify-end py-5">
      <div class="portal-content right-bg sm:mr-2" @click="$emit('clickCard')">
        <div class="icon md:mr-4 select-none">
          <img :src="portalIcon.url" :style="portalIcon.style" />
        </div>
        <div class="flex flex-col sm:px-6 w-3/5 sm:w-4/5">
          <div v-if="isDone && isPractice" class="tag">已完成</div>
          <span class="text-xl w-full font-semibold text-white pb-3 truncate title">{{
            content.title
          }}</span>
          <span class="w-full text-base text-white pt-5 truncate-two">{{ content.desc }} </span>
        </div>
      </div>
      <div
        v-tooltip="{ content: content.name, show: tooltipVisible }"
        class="hidden sm:block flex-shrink-0 -mb-1 relative"
        @touchstart="handleImgClick"
      >
        <img :src="avatar" class="w-10 h-10 rounded-full object-cover" />
      </div>
    </div>
    <div v-else class="flex py-5">
      <div
        v-tooltip="{ content: content.name, show: tooltipVisible }"
        class="hidden sm:block flex-shrink-0 -mb-1 relative"
        @touchstart="handleImgClick"
      >
        <img :src="avatar" class="w-10 h-10 rounded-full object-cover" />
      </div>
      <div class="portal-content left-bg" @click="$emit('clickCard')">
        <div v-if="isDone && isPractice" class="tag">已完成</div>
        <div class="flex flex-1 flex-col pr-4 w-3/5">
          <span class="text-xl w-full font-semibold text-white pb-3 truncate title">{{
            content.title
          }}</span>
          <span class="w-full text-base text-white pt-5 truncate-two">{{ content.desc }} </span>
        </div>
        <div class="justify-end icon md:mr-4 select-none">
          <img :src="portalIcon.url" :style="portalIcon.style" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Content, Sequence } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PortalCard extends Vue {
  @Prop({ type: Object }) content!: Content & {
    portalSequence: Sequence;
    name: string;
    style: string;
  };
  @Prop({ type: Array }) characters!: Array<{
    name: string;
    avatar: string;
    direction?: 'right' | 'left';
  }>;
  @Prop({ type: Boolean }) isDone: boolean;

  tooltipVisible = false;
  timeoutId: number | undefined;

  get portalIcon() {
    switch (this.content.style) {
      case '练习':
      case 'practice':
        return {
          url: require('./assets/practice.svg'),
          style: 'transform: scale(1.2);'
        };

      default:
        return {
          url: require('./assets/portal.svg'),
          style: 'transform: scale(1);'
        };
    }
  }

  get isPractice() {
    return ['练习', 'practice'].includes(this.content.style);
  }

  get avatar() {
    const avatar = this.characters.filter((item) => item.name === this.content.name)[0]?.avatar;
    avatar && this.$emit('getCurrentAvatar', avatar);
    return avatar;
  }

  get direction() {
    const direction = this.characters.filter((item) => item.name === this.content.name)[0]
      ?.direction;
    return direction;
  }

  handleImgClick(e: MouseEvent) {
    e.preventDefault();
    this.timeoutId && clearTimeout(this.timeoutId);
    this.tooltipVisible = !this.tooltipVisible;
    this.tooltipVisible &&
      (this.timeoutId = window.setTimeout(() => {
        this.tooltipVisible = false;
      }, 1000));
  }
}
</script>

<style scoped>
.portal-content {
  @apply flex items-center justify-between sm:ml-2 w-full sm:w-4/5 md:w-112 max-w-md h-40 p-6 hover:shadow-lg rounded-motif cursor-pointer relative;
  transition: transform 0.3s linear;
}

.right-bg {
  background: linear-gradient(89deg, #667fff -3%, #798fff 102%);
}

.left-bg {
  background: linear-gradient(89deg, #667fff -3%, #798fff 102%);
}

.portal-content:hover {
  transform: translateY(-0.25rem);
}

.truncate-two {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
}
.title {
  @apply relative;
}
.title::after {
  background-color: rgb(243, 244, 246);
  content: ' ';
  @apply absolute bottom-0 left-0 w-20 h-1 rounded-full;
}
.icon {
  flex: 0 0 6rem;
}
.tag {
  @apply absolute flex items-center justify-center w-16 h-8 top-2 left-0 text-white;
  width: 51px;
  height: 20px;
  background-color: #a6c4ff;
  border-radius: 0px 12px 12px 0px;
}
</style>
